export const data = {   
    layouts: [
        {label: "Grid", value: "grid"},
        {label: "Flex", value: "flex"},
        {label: "None", value: "none"},
    ],
    flexDirection: [
        {label: "Column", value: "column"},
        {label: "Row", value: "row"},
    ],
    flexAlignItems: [
        {label: "Normal", value: "normal"},
        {label: "Center", value: "center"},
        {label: "Flex start", value: "flex-start"},
        {label: "Flex end", value: "flex-end"},
        {label: "Stretch", value: "stretch"},
        {label: "Baseline", value: "baseline"},
    ],
    flexJustifyContent: [
        {label: "Normal", value: "normal"},
        {label: "Center", value: "center"},
        {label: "Flex start", value: "flex-start"},
        {label: "Flex end", value: "flex-end"},
        {label: "Space between", value: "space-between"},
        {label: "Space around", value: "space-around"},
        {label: "Space evenly", value: "space-evenly"},
    ],
    spacing: [
        { label: '0', value: '0px' },
        { label: '1', value: '1px' },
        { label: '0.5', value: '2px' },
        { label: '1', value: '4px' },
        { label: '1.5', value: '6px' },
        { label: '2', value: '8px' },
        { label: '2.5', value: '10px' },
        { label: '3', value: '12px' },
        { label: '3.5', value: '14px' },
        { label: '4', value: '16px' },
        { label: '5', value: '20px' },
        { label: '6', value: '24px' },
        { label: '7', value: '28px' },
        { label: '8', value: '32px' },
        { label: '9', value: '36px' },
        { label: '10', value: '40px' },
        { label: '11', value: '44px' },
        { label: '12', value: '48px' },
        { label: '13', value: '56px' },
        { label: '14', value: '64px' },
        { label: '16', value: '80px' },
        { label: '20', value: '96px' },
        { label: '24', value: '112px' },
        { label: '28', value: '128px' },
        { label: '32', value: '144px' },
        { label: '40', value: '160px' },
        { label: '44', value: '176px' },
        { label: '48', value: '192px' },
        { label: '52', value: '208px' },
        { label: '56', value: '224px' },
        { label: '60', value: '240px' },
        { label: '64', value: '256px' },
        { label: '72', value: '288px' },
        { label: '80', value: '320px' },
        { label: '96', value: '384px' },
    ],
    rows: [
        { label: '0', value: '0' },
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        { label: '5', value: '5' },
        { label: '6', value: '6' },
        { label: '7', value: '7' },
        { label: '8', value: '8' },
        { label: '9', value: '9' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '13', value: '13' },
        { label: '14', value: '14' },
        { label: '15', value: '15' },
        { label: '16', value: '16' },
        { label: '17', value: '17' },
        { label: '18', value: '18' },
        { label: '19', value: '19' },
        { label: '20', value: '20' },
        { label: '21', value: '21' },
        { label: '22', value: '22' },
        { label: '23', value: '23' },
        { label: '24', value: '24' },
        { label: '25', value: '25' },
        { label: '26', value: '26' },
        { label: '27', value: '27' },
        { label: '28', value: '28' },
        { label: '29', value: '29' },
        { label: '30', value: '30' },
        { label: '31', value: '31' },
        { label: '32', value: '32' },
        { label: '33', value: '33' },
        { label: '34', value: '34' },
        { label: '35', value: '35' },
        { label: '36', value: '36' },
        { label: '37', value: '37' },
        { label: '38', value: '38' },
        { label: '39', value: '39' },
        { label: '40', value: '40' },
        { label: '41', value: '41' },
        { label: '42', value: '42' },
        { label: '43', value: '43' },
        { label: '44', value: '44' },
        { label: '45', value: '45' },
        { label: '46', value: '46' },
        { label: '47', value: '47' },
        { label: '48', value: '48' },
    ],
    cols: [
        { label: '0', value: '0' },
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        { label: '5', value: '5' },
        { label: '6', value: '6' },
        { label: '7', value: '7' },
        { label: '8', value: '8' },
        { label: '9', value: '9' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '13', value: '13' },
        { label: '14', value: '14' },
        { label: '15', value: '15' },
        { label: '16', value: '16' },
        { label: '17', value: '17' },
        { label: '18', value: '18' },
        { label: '19', value: '19' },
        { label: '20', value: '20' },
        { label: '21', value: '21' },
        { label: '22', value: '22' },
        { label: '23', value: '23' },
        { label: '24', value: '24' },
        { label: '25', value: '25' },
        { label: '26', value: '26' },
        { label: '27', value: '27' },
        { label: '28', value: '28' },
        { label: '29', value: '29' },
        { label: '30', value: '30' },
        { label: '31', value: '31' },
        { label: '32', value: '32' },
        { label: '33', value: '33' },
        { label: '34', value: '34' },
        { label: '35', value: '35' },
        { label: '36', value: '36' },
        { label: '37', value: '37' },
        { label: '38', value: '38' },
        { label: '39', value: '39' },
        { label: '40', value: '40' },
        { label: '41', value: '41' },
        { label: '42', value: '42' },
        { label: '43', value: '43' },
        { label: '44', value: '44' },
        { label: '45', value: '45' },
        { label: '46', value: '46' },
        { label: '47', value: '47' },
        { label: '48', value: '48' },
    ],
    gridSpan: [
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        { label: '5', value: '5' },
        { label: '6', value: '6' },
        { label: '7', value: '7' },
        { label: '8', value: '8' },
        { label: '9', value: '9' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '13', value: '13' },
        { label: '14', value: '14' },
        { label: '15', value: '15' },
        { label: '16', value: '16' },
        { label: '17', value: '17' },
        { label: '18', value: '18' },
        { label: '19', value: '19' },
        { label: '20', value: '20' },
        { label: '21', value: '21' },
        { label: '22', value: '22' },
        { label: '23', value: '23' },
        { label: '24', value: '24' },
        { label: '25', value: '25' },
        { label: '26', value: '26' },
        { label: '27', value: '27' },
        { label: '28', value: '28' },
        { label: '29', value: '29' },
        { label: '30', value: '30' },
        { label: '31', value: '31' },
        { label: '32', value: '32' },
        { label: '33', value: '33' },
        { label: '34', value: '34' },
        { label: '35', value: '35' },
        { label: '36', value: '36' },
        { label: '37', value: '37' },
        { label: '38', value: '38' },
        { label: '39', value: '39' },
        { label: '40', value: '40' },
        { label: '41', value: '41' },
        { label: '42', value: '42' },
        { label: '43', value: '43' },
        { label: '44', value: '44' },
        { label: '45', value: '45' },
        { label: '46', value: '46' },
        { label: '47', value: '47' },
        { label: '48', value: '48' },
    ],
    gridAutoRows: [
        { label: "Auto", value: "auto-rows-auto" },
        { label: "Max content", value: "auto-rows-max" },
        { label: "Min content", value: "auto-rows-min" },
        { label: "Unset", value: "unset" },
    ],
    fontSize: [
        { label: 'xs', value: 'xs' },
        { label: 'sm', value: 'sm' },
        { label: 'base', value: 'base' },
        { label: 'lg', value: 'lg' },
        { label: 'xl', value: 'xl' },
        { label: '2xl', value: '2xl' },
        { label: '3xl', value: '3xl' },
        { label: '4xl', value: '4xl' },
        { label: '5xl', value: '5xl' },
        { label: '6xl', value: '6xl' },
        { label: '7xl', value: '7xl' },
        { label: '8xl', value: '8xl' },
        { label: '9xl', value: '9xl' },
    ],
    fontWeight: [
        { label: '100', value: '100' },
        { label: '200', value: '200' },
        { label: '300', value: '300' },
        { label: '400', value: '400' },
        { label: '500', value: '500' },
        { label: '600', value: '600' },
        { label: '700', value: '700' },
        { label: '800', value: '800' },
        { label: '900', value: '900' },
    ],
    fontFamily:{
       "windows": [
        { "label": "Inherit", "value": "Inherit" },
        { "label": "Arial", "value": "Arial" },
        { "label": "Arial Black", "value": "Arial Black" },
        { "label": "Bahnschrift", "value": "Bahnschrift" },
        { "label": "Calibri", "value": "Calibri" },
        { "label": "Cambria", "value": "Cambria" },
        { "label": "Candara", "value": "Candara" },
        { "label": "Comic Sans MS", "value": "Comic Sans MS" },
        { "label": "Consolas", "value": "Consolas" },
        { "label": "Constantia", "value": "Constantia" },
        { "label": "Corbel", "value": "Corbel" },
        { "label": "Courier New", "value": "Courier New" },
        { "label": "Georgia", "value": "Georgia" },
        { "label": "Impact", "value": "Impact" },
        { "label": "Lucida Console", "value": "Lucida Console" },
        { "label": "Lucida Sans Unicode", "value": "Lucida Sans Unicode" },
        { "label": "Microsoft Sans Serif", "value": "Microsoft Sans Serif" },
        { "label": "Palatino Linotype", "value": "Palatino Linotype" },
        { "label": "Segoe UI", "value": "Segoe Ui" },
        { "label": "Segoe UI Symbol", "value": "Segoe Ui Symbol" },
        { "label": "Tahoma", "value": "Tahoma" },
        { "label": "Times New Roman", "value": "Times New Roman" },
        { "label": "Trebuchet MS", "value": "Trebuchet MS" },
        { "label": "Verdana", "value": "Verdana" },
        { "label": "Webdings", "value": "Webdings" },
        { "label": "Wingdings", "value": "Wingdings" }
      ]
      ,
        "macOS":[
            { "label": "Arial", "value": "Arial" },
            { "label": "Arial Black", "value": "Arial Black" },
            { "label": "Arial Narrow", "value": "Arial Narrow" },
            { "label": "Arial Rounded MT Bold", "value": "Arial Rounded Mt Bold" },
            { "label": "Comic Sans MS", "value": "Comic Sans Ms" },
            { "label": "Courier", "value": "Courier" },
            { "label": "Courier New", "value": "Courier New" },
            { "label": "Geneva", "value": "Geneva" },
            { "label": "Helvetica", "value": "Helvetica" },
            { "label": "Helvetica Neue", "value": "Helvetica Neue" },
            { "label": "Impact", "value": "Impact" },
            { "label": "Lucida Grande", "value": "Lucida Grande" },
            { "label": "Monaco", "value": "Monaco" },
            { "label": "Palatino", "value": "Palatino" },
            { "label": "Palatino Linotype", "value": "Palatino Linotype" },
            { "label": "Tahoma", "value": "Tahoma" },
            { "label": "Times", "value": "Times" },
            { "label": "Times New Roman", "value": "Times New Roman" },
            { "label": "Trebuchet MS", "value": "Trebuchet Ms" },
            { "label": "Verdana", "value": "Verdana" },
            { "label": "Zapf Dingbats", "value": "Zapf Dingbats" }
          ]
          ,
        "linux":[
            { "label": "Arial", "value": "Arial" },
            { "label": "Calibri", "value": "Calibri" },
            { "label": "Cantarell", "value": "Cantarell" },
            { "label": "DejaVu Sans", "value": "Dejavu Sans" },
            { "label": "Droid Sans", "value": "Droid Sans" },
            { "label": "FreeMono", "value": "Freemono" },
            { "label": "FreeSans", "value": "Freesans" },
            { "label": "FreeSerif", "value": "Freeserif" },
            { "label": "Georgia", "value": "Georgia" },
            { "label": "Helvetica", "value": "Helvetica" },
            { "label": "Liberation Mono", "value": "Liberation Mono" },
            { "label": "Liberation Sans", "value": "Liberation Sans" },
            { "label": "Liberation Serif", "value": "Liberation Serif" },
            { "label": "Lucida Console", "value": "Lucida Console" },
            { "label": "Noto Sans", "value": "Noto Sans" },
            { "label": "Noto Serif", "value": "Noto Serif" },
            { "label": "Open Sans", "value": "Open Sans" },
            { "label": "Roboto", "value": "Roboto" },
            { "label": "Tahoma", "value": "Tahoma" },
            { "label": "Times New Roman", "value": "Times New Roman" },
            { "label": "Trebuchet MS", "value": "Trebuchet Ms" },
            { "label": "Ubuntu", "value": "Ubuntu" },
            { "label": "Verdana", "value": "Verdana" }
          ]
          

    },
    radius: [
        { label: 'none', value: 'none' },
        { label: 'sm', value: 'sm' },
        { label: 'base', value: 'base' },
        { label: 'md', value: 'md' },
        { label: 'lg', value: 'lg' },
        { label: 'xl', value: 'xl' },
        { label: '2xl', value: '2xl' },
        { label: '3xl', value: '3xl' },
        { label: 'full', value: 'full' },
    ],
    border: [
        { label: '0', value: '0' },
        { label: '2', value: '2' },
        { label: '4', value: '4' },
        { label: '8', value: '8' },
    ],
    dimensions: [
        { label: 'Fit', value: 'fit' },
        { label: '100%', value: 'full' },
        { label: '83.3%', value: '5/6' },
        { label: '80%', value: '4/5' },
        { label: '66.6%', value: '4/6' },
        { label: '60%', value: '3/5' },
        { label: '50%', value: '3/6' },
        { label: '40%', value: '2/5' },
        { label: '33.3%', value: '2/6' },
        { label: '20%', value: '1/5' },
        { label: '16.6%', value: '1/6' },
        { label: '16.6%', value: '1/6' },
        { label: '16.6%', value: '1/6' },
        { label: '0.5', value: '0.5' },
        { label: '1', value: '1' },
        { label: '1.5', value: '1.5' },
        { label: '2', value: '2' },
        { label: '2.5', value: '2.5' },
        { label: '3', value: '3' },
        { label: '3.5', value: '3.5' },
        { label: '4', value: '4' },
        { label: '5', value: '5' },
        { label: '6', value: '6' },
        { label: '7', value: '7' },
        { label: '8', value: '8' },
        { label: '9', value: '9' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '14', value: '14' },
        { label: '16', value: '16' },
        { label: '20', value: '20' },
        { label: '24', value: '24' },
        { label: '28', value: '28' },
        { label: '32', value: '32' },
        { label: '36', value: '36' },
        { label: '40', value: '40' },
        { label: '44', value: '44' },
        { label: '48', value: '48' },
        { label: '52', value: '52' },
        { label: '56', value: '56' },
        { label: '60', value: '60' },
        { label: '64', value: '64' },
        { label: '72', value: '72' },
        { label: '80', value: '80' },
        { label: '96', value: '96' },
    ],
    alignX: [
        { label: 'Select horizontal position', value: '' },
        { label: 'Left', value: 'start' },
        { label: 'Center', value: 'center' },
        { label: 'Right', value: 'end' },
    ],
    alignY: [
        { label: 'Select vertical position', value: ''},
        { label: 'Top', value: 'start' },
        { label: 'Center', value: 'center' },
        { label: 'Bottom', value: 'end' },
    ],
    overflowX: [
        { label: 'Auto', value: 'auto'},
        { label: 'Scroll', value: 'scroll' },
        { label: 'Hidden', value: 'hidden' },
        { label: 'Unset', value: 'unset' },
    ],
    overflowY: [
        { label: 'Auto', value: 'auto'},
        { label: 'Scroll', value: 'scroll' },
        { label: 'Hidden', value: 'hidden' },
        { label: 'Unset', value: 'unset' },
    ],
    heightMode: [
        { label: "%", value: "%" },
        { label: "px", value: "px" },
        { label: "Auto", value: "auto" },
        { label: "Max", value: "max-content" },
        { label: "Min", value: "min-content" }
    ],
    widthMode: [
        { label: "%", value: "%" },
        { label: "px", value: "px" },
        { label: "Auto", value: "auto" },
        { label: "Max", value: "max-content" },
        { label: "Min", value: "min-content" }
    ],
    wizardWidthMode: [
        { label: "%", value: "%" },
        { label: "px", value: "px" }
    ]
}

export const getFlexDistributeOptions = (type: 'Row' | 'Column', axis: 'main' | 'cross') => {
    const props = []
    if (axis === 'main') {
        props.push({ label: type === 'Row' ? "Left" : "Top", value: "start" })
        props.push({ label: type === 'Row' ? "Right" : "Bottom", value: "end" })
        props.push({ label: 'Center', value: 'center' })
        props.push({ label: 'Space between', value: 'space-between' })
        props.push({ label: 'Space around', value: 'space-around' })
        props.push({ label: 'Space evenly', value: 'space-evenly' })
    } else {
        props.push({ label: type === 'Row' ? "Top" : "Left", value: "start" })
        props.push({ label: type === 'Row' ? "Bottom" : "Right", value: "end" })
        props.push({ label: 'Center', value: 'center' })
    }

    return props
}